<template>
  <div class="xb-launch-order-return">
    <Breadcrumb :breadcrumbData="breadcrumbData"></Breadcrumb>
    <div class="launch-return-main">
      <div class="message">
        <div class="left">
          <p>
            <span>下单时间：</span>
            <span>{{ list.time }}</span>
          </p>
          <p>
            <span>订单号：</span>
            <span>{{ list.code }}</span>
          </p>
        </div>
      </div>
      <div class="table-img">
        <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column width="50">
            <template slot-scope="scope">
              <el-checkbox :disabled="scope.row.isTemp" v-model="scope.row.checked"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="名称">
            <template slot-scope="scope">
              <img class="img" :src="scope.row.img" alt />
              <p class="name">{{scope.row.name}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="specifications" label="规格"></el-table-column>
          <el-table-column prop="price" label="单价" width="152"></el-table-column>
          <el-table-column prop="number" label="数量" width="152">
            <template slot-scope="scope">
              <el-input
                class="gray"
                :disabled="scope.row.isTemp"
                @blur="changeValue(scope.row.number, scope.$index, scope.row.maxNumber)"
                v-model="scope.row.number"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="sum" label="小计" width="152"></el-table-column>
        </el-table>
        <div class="table-footer">
          <div class="total">
            <span>订单合计：</span>
            <span class="price">￥{{totalPrice}}</span>
          </div>
          <div class="actual-amount">
            <span>实际退货金额：</span>
            <span class="price">￥{{realRefundMoney}}</span>
          </div>
        </div>
      </div>
      <div class="remarks">
        <span class="tit">退货留言：</span>
        <el-input type="textarea" autosize placeholder="请输入内容" v-model="remarks" class="gray"></el-input>
      </div>
      <div class="button-footer">
        <el-button class="red" @click="submit">确认退货</el-button>
        <el-button class="white" @click="back">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "base/xb-base/Breadcrumb";
import XBOrder from "models/xb/order.js";
import XBOrderReturn from "models/xb/orderReturn.js";
const xbOrder = new XBOrder();
const xbOrderReturn = new XBOrderReturn();
const defaultGoodPic = "http://image.8844it.com/ydb2/goodDefault.png";
export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      breadcrumbData: [
        {
          name: "订货单",
          url: "/personal/personal-menu/xb-order",
        },
        {
          name: "发起退单",
          url: "",
        },
      ],
      list: {
        code: "",
        time: "",
        refundCode: "",
      },
      tableData: [
        // {
        //   img: 'https://i1.mifile.cn/a1/pms_1550642182.7527088!220x220.jpg',
        //   name: '哈哈哈哈哈哈哈哈哈哈哈哈',
        //   price: '￥12.00',
        //   number: 100,
        //   sum: 1200
        // }
      ],
      remarks: "",
      totalPrice: 0, // 退货金额
      realRefundMoney: 0, // 实际退货金额
      multipleSelection: [], // 选中数据
    };
  },
  beforeMount() {
    let orderCode = this.$route.query.orderCode;
    this.list.code = orderCode;
    this.getData(orderCode);
  },
  methods: {
    // 获取发起退单信息
    getData(orderCode) {
      xbOrder.getReturnOrderDetailByOrderCode(orderCode).then((res) => {
        if (res.success) {
          this.list.time = this.fmtDate(res.result.createOrderTime);
          this.totalPrice = res.result.totalPrice;
          this.list.refundCode = res.result.refundCode;
          this.realRefundMoney = res.result.realRefundMoney;
          let arr = [];
          res.result.goodsList.map((value, index, array) => {
            let obj = {};
            obj.id = value.id;
            obj.isTemp = false;
            obj.checked = false;
            obj.img = value.goodsPic ? value.goodsPic : defaultGoodPic;
            obj.name = value.goodsName;
            obj.price = value.price;
            obj.number = value.num;
            obj.maxNumber = value.num;
            obj.sum = value.subtotal;
            let specifications = JSON.parse(value.itemTitle);
            let str = "";
            Object.keys(specifications).map((value) => {
              str += specifications[value] + " ; ";
            });
            obj.specifications = str;
            arr.push(obj);
          });
          res.result.tempOrderDetailList.map((value) => {
            let obj = {};
            obj.isTemp = true;
            obj.checked = false;
            obj.id = value.id;
            obj.img = value.goodsPic ? value.goodsPic : defaultGoodPic;
            obj.name = value.goodsName;
            obj.price = value.unitPrice;
            obj.number = value.quantity;
            obj.sum = value.subtotal;
            obj.specifications = value.itemTitle;
            arr.push(obj);
          });
          this.tableData = arr;
        }
      });
    },
    // 当弹窗输入框发生改变
    changeValue(val, index, maxVal) {
      val = Number(val);
      maxVal = Number(maxVal);
      let number = /(^[1-9]+[0-9]*$)/.test(val);
      if (number) {
        if (val >= maxVal) {
          this.$set(this.tableData[index], "number", maxVal);
        } else {
          this.$set(this.tableData[index], "number", val);
        }
      } else {
        this.$set(this.tableData[index], "number", 1);
      }
    },
    // 选中数据
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 时间格式转换
    fmtDate(date) {
      let dateFn = new Date(date);
      let yy = dateFn.getFullYear();
      let mm = dateFn.getMonth() + 1;
      let dd = dateFn.getDate();
      let hh =
        dateFn.getHours() < 10
          ? "0" + dateFn.getHours()
          : "" + dateFn.getHours();
      let xx =
        dateFn.getMinutes() < 10
          ? "0" + dateFn.getMinutes()
          : "" + dateFn.getMinutes();
      let ss =
        dateFn.getSeconds() < 10
          ? "0" + dateFn.getSeconds()
          : "" + dateFn.getSeconds();
      let time = yy + "-" + mm + "-" + dd + " " + hh + ":" + xx + ":" + ss;
      return time;
    },
    // 发起退货
    submit() {
      let orderDetailList = [];
      let orderCode = this.list.code;
      let refundCode = this.list.refundCode;
      let message = this.remarks;
      this.tableData.map((value) => {
        if (!value.isTemp && value.checked) {
          let obj = {};
          obj.id = value.id;
          obj.num = value.number;
          orderDetailList.push(obj);
        }
      });
      if (orderDetailList.length === 0) {
        this.$message.error("请选择退货商品");
        return false;
      }
      let data = {
        orderDetailList,
        orderCode,
        refundCode,
        message,
      };
      xbOrderReturn.postXBConfirmReturn(data).then((res) => {
        if (res.success) {
          this.$message.success("发起退货成功");
          this.$router.push("/personal/personal-menu/xb-order-return");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 返回上一页
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang='scss' scoped>
.xb-launch-order-return {
  color: #606266;
  letter-spacing: 1px;
  .launch-return-main {
    padding: 20px;
    background: #fff;
    min-height: 600px;
    .message {
      display: flex;
      height: 32px;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      margin-bottom: 20px;
      .left {
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
          margin-right: 100px;
        }
      }
      .right {
        .el-button {
          width: 120px;
          height: 32px;
          border-radius: 4px;
          border: 1px solid rgba(223, 52, 69, 1);
          background: #fff;
          font-size: 16px;
          color: rgba(223, 52, 69, 1);
        }
      }
    }
    .table-img {
      margin-bottom: 24px;
      .el-button {
        color: rgba(232, 54, 50, 1);
      }
      .table-footer {
        height: 32px;
        box-sizing: border-box;
        border: 1px solid #f2f6fc;
        border-top: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 14px;
        .total {
          width: 208px;
          .price {
            font-size: 16px;
          }
        }
        .actual-amount {
          width: 248px;
          .price {
            font-size: 16px;
            color: #df3445;
          }
        }
      }
    }
    .remarks {
      display: flex;
      font-size: 14px;
      align-items: flex-start;
      .tit {
        line-height: 20px;
      }
    }
    .button-footer {
      padding-top: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-button + .el-button {
        margin-left: 24px;
      }
      .el-button {
        width: 80px;
        height: 32px;
        padding: 0;
        letter-spacing: 1px;
      }
      .red {
        background: rgba(223, 52, 69, 1);
        border-radius: 4px;
        color: white;
        border: 1px solid rgba(223, 52, 69, 1);
      }
      .white {
        background: white;
        border-radius: 4px;
        color: rgba(223, 52, 69, 1);
        border: 1px solid rgba(223, 52, 69, 1);
      }
    }
  }
}
</style>
<style lang="scss">
.xb-launch-order-return {
  .remarks {
    .el-textarea {
      width: 380px;
      .el-textarea__inner {
        min-height: 80px !important;
        background: rgba(234, 238, 245, 0.2);
        border-radius: 8px;
        border: 1px solid rgba(234, 238, 245, 1);
      }
    }
  }
}
</style>
